import { CSSResultGroup, TemplateResult, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import componentStyles from './ghs-bottom.css.lit';
import { OutlineElement } from '../../base/outline-element/outline-element';

/**
 * The GhsBottom component - intended to be used as a
 * “Back to top link” placed at the bottom of a page
 * @element ghs-bottom
 */
@customElement('ghs-bottom')
export class GhsBottom extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  render(): TemplateResult {
    return html`
      <a href="#top" class="alt">
        <div>Back to Top</div>
        <ghs-icon
          size="30px"
          mobile-size="30px"
          name="back-to-top"
          site=${this.site}
        >
        </ghs-icon>
      </a>
    `;
  }
}
